

<app-subscription-grouping-student-index
*ngIf="subscriptionGrouping"
[subscriptionGrouping]="subscriptionGrouping">
</app-subscription-grouping-student-index>

<!-- Modal-->
<app-subscription-grouping-student-new
*ngIf="subscriptionGrouping"
[subscriptionGrouping]="subscriptionGrouping"
(finishedGroupTrialRegStudentEmitter)="closeModalByName($event)">
</app-subscription-grouping-student-new>
<!-- Modal End-->
<div class ="text-center">
  <a (click)="openNewStudentPopup()" class="mt-1 me-2 btn btn-primary"> Enrol Student</a>
  <a *ngIf="subscriptionGrouping"
  [routerLink]="['/batch/group/show',subscriptionGroup.server_subscription_group_id]" class="mt-1 btn btn-primary"> <i class="fa fa-list"></i> List</a>
</div>

